export default __webpack_public_path__ + "dummy.5c1e6727bd44c3ae8f2e6b2bfa821461.png";